import { useEffect, useState } from "react";
import type { EmblaCarouselType } from "embla-carousel";

/** Mirrors the Embla selection and scroll bounds into React state. */
export const useCarouselState = (api: EmblaCarouselType | undefined) => {
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
	const [canScrollPrev, setCanScrollPrev] = useState(false);
	const [canScrollNext, setCanScrollNext] = useState(false);

	useEffect(() => {
		if (!api) {
			return undefined;
		}

		const syncSelection = () => {
			setSelectedIndex(api.selectedScrollSnap());
			setCanScrollPrev(api.canScrollPrev());
			setCanScrollNext(api.canScrollNext());
		};

		const syncSnaps = () => {
			setScrollSnaps(api.scrollSnapList());
			syncSelection();
		};

		syncSnaps();
		api.on("select", syncSelection);
		api.on("reInit", syncSnaps);

		return () => {
			api.off("select", syncSelection);
			api.off("reInit", syncSnaps);
		};
	}, [api]);

	return { selectedIndex, scrollSnaps, canScrollPrev, canScrollNext };
};
